/**
 * Nasty Hack for IE
 * Only the first letter of the value appears in the select so we need to force a redraw
 * Explictly had to set the width and then set back to original value to force this
 */
angular.module('qkr').directive('select', ($window) => ({
        restrict: 'E',
        link(scope, element, attrs) {
            scope.$watch(attrs.ngModel, (newValue, oldValue) => {
                // Check for IE
                if ($window.navigator.appVersion.indexOf('MSIE') !== -1) {
                    const width = element.css('width');
                    element.css('width', '1px');
                    element.css('width', width);
                }
            });
        }
    }));



// WEBPACK FOOTER //
// ./src/directives/ie_select_hack.js